import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Box, Stack, Drawer, Typography } from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
import useCollapseDrawer from '../../../hooks/useCollapseDrawer';
// utils
import cssStyles from '../../../utils/cssStyles';
// config
import { NAVBAR } from '../../../config';
// components
import Scrollbar from '../../../components/Scrollbar';
import { NavSectionVertical } from '../../../components/nav-section';
import Image from '../../../components/Image';
import Iconify from '../../../components/Iconify';
//
import navConfig from './NavConfig';
import CollapseButton from './CollapseButton';
import useLocales from '../../../hooks/useLocales';
import palette from '../../../theme/palette';
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

// ----------------------------------------------------------------------

NavbarVertical.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function NavbarVertical({ handleSideBar, isOpenSidebar, onCloseSidebar }) {
  const theme = useTheme();

  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  const navigate = useNavigate();

  const { translate } = useLocales();

  const { isCollapse, collapseClick, collapseHover, onToggleCollapse, onHoverEnter, onHoverLeave } =
    useCollapseDrawer();

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Stack direction={'column'} justifyContent={'space-between'} flex={1} sx={{ height: '100%' }}>
        <Box sx={{ flex: 1 }}>
          {/* <Stack
            spacing={3}
            sx={{
              p: 1,
              flexShrink: 0,
              mt: 1,
              // mb: 1,
              ...(isCollapse && { alignItems: 'center' }),
            }}
          >
            <Stack direction="row" alignItems="center" justifyContent="end" sx={{ width: '100%' }}>
              {!isDesktop && (
                <>
                  <Stack flex={1} direction="row" alignItems="center" spacing={0.5} pl={1}>
                    <Box onClick={() => navigate('/')}>
                      <Image
                        src={require('../../../assets/brand-logo.png')}
                        alt=""
                        sx={{
                          cursor: 'pointer',
                          width: '100px',
                          height: '23px',
                          '& img': { maxHeight: '10vh' },
                        }}
                      />
                    </Box>
                  </Stack>
                  <CollapseButton onToggleCollapse={onCloseSidebar} collapseClick={!isOpenSidebar} />
                </>
              )}
            </Stack>
          </Stack> */}
          <NavSectionVertical navConfig={navConfig} isCollapse={isCollapse} onCloseSidebar={onCloseSidebar} />
        </Box>
      </Stack>
    </Scrollbar>
  );

  return (
    <RootStyle
      sx={{
        width: isCollapse ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH : NAVBAR.DASHBOARD_WIDTH,
        transition: 'width 0.3s ease',
      }}
    >
      <Box sx={{ position: 'relative' }}>
        {/* <Image
          onClick={handleSideBar}
          src={require('../../../assets/side-nav/collapse_icon.png')}
          sx={{
            width: '40px',
            height: '40px',
            position: 'absolute',
            right: "-20px",
            top: '150px',
            // marginLeft: '274px',
            zIndex: 9999,
            cursor: 'pointer',
          }}
        /> */}
        {!isDesktop && (
          <>
            {isOpenSidebar && <Box className="mobile-nav-backdrop" />}
            <Drawer
              variant="persistent"
              open={isOpenSidebar}
              onClose={onCloseSidebar}
              PaperProps={{
                sx: {
                  width: NAVBAR.DASHBOARD_WIDTH,
                  background: palette.navBarVertical.bg,
                },
              }}
            >
              {renderContent}
            </Drawer>
          </>
        )}

        {isDesktop && (
          <Drawer
            open={isOpenSidebar}
            // onClose={onCloseSidebar}
            variant="persistent"
            hideBackdrop={true}
            // onMouseEnter={onHoverEnter}
            // onMouseLeave={onHoverLeave}
            PaperProps={{
              sx: {
                height: '100%',
                top: 'unset',
                bottom: 0,
                width: isCollapse ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH : NAVBAR.DASHBOARD_WIDTH,
                px: 1,
                pt: 0,
                background: palette.navBarVertical.bg,
                border: 'none',
                boxSizing: 'border-box',
                visibility: 'unset !important',
                transform: 'unset !important',
                zIndex: 1100,
                transition: (theme) =>
                  theme.transitions.create('margin', {
                    duration: theme.transitions.duration.enteringScreen,
                    easing: theme.transitions.easing.easeInOut,
                  }),
                ...(isCollapse &&
                  {
                    // width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
                  }),
                // ...(collapseHover && {
                //   ...cssStyles(theme).bgBlur(),
                //   boxShadow: (theme) => theme.customShadows.z24,
                // }),
              },
            }}
          >
            <Image
              onClick={onToggleCollapse}
              src={require('../../../assets/side-nav/collapse_icon.png')}
              sx={{
                width: '40px',
                height: '40px',
                position: 'fixed',
                top: '150px',
                left: isCollapse ? '80px' : `${NAVBAR.DASHBOARD_WIDTH - 20}px`,
                zIndex: 2000,
                cursor: 'pointer',
                transition: 'left 0.3s ease',
                transform: isCollapse ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
            />
            {renderContent}
          </Drawer>
        )}
      </Box>
    </RootStyle>
  );
}
